import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconExternalLink = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName, className);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 11 11"
      className={classes}
    >
      <path
        fill="#1d1d1b"
        d="M7.64 11H1.45C.65 11 0 10.35 0 9.551V3.367c0-.8.65-1.449 1.45-1.449H5c.28 0 .5.22.5.5s-.22.5-.5.5H1.45c-.25 0-.45.2-.45.449V9.55c0 .25.2.45.45.45h6.19c.25 0 .45-.2.45-.45V5.295c0-.28.22-.5.5-.5s.5.22.5.5v4.256c0 .8-.65 1.449-1.45 1.449M4.66 7.044 10.85.859c.2-.2.2-.51 0-.71s-.51-.199-.71 0L3.95 6.335c-.2.2-.2.51 0 .71a.485.485 0 0 0 .7 0zm6.33-2.258V.5c0-.28-.22-.5-.5-.5H6.32c-.28 0-.5.22-.5.5s.22.5.5.5h3.67v3.786c0 .28.22.5.5.5s.5-.22.5-.5"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconExternalLink.defaultProps = {
  className: null,
  rootClassName: null,
};

IconExternalLink.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconExternalLink;
